import React from 'react'
import AppStoreButtons from './app-store-buttons'

export const PrincipalAppStoreButtons = ({ className = '' }) => {
  return (
    <AppStoreButtons
      className={className}
      iosLink="https://itunes.apple.com/us/app/total-milk-principal-dashboard/id1229470126?ls=1&mt=8"
      googleLink="https://play.google.com/store/apps/details?id=com.totalmilk.principal"
    />
  )
}
